import type { FC } from 'react';
import styles from './QuotesSection.module.scss';

type QuoteProps = {
  quote: string;
  outlet: string;
};

const Quote: FC<QuoteProps> = ({ quote, outlet }) => (
  <div className={styles.item}>
    <dd className={styles.quote}>{quote}</dd>
    <dt className={styles.outlet}>{`- ${outlet}`}</dt>
  </div>
);

export default Quote;
